import React from "react";
import Icon from './Icon';

export default class Feed extends React.PureComponent {
    render() {
        return (
            <Icon className={'feed'} img={require('../../../assets/images/icons/feed.svg')}/>
        );
    }
}
